import layoutAdmin from '@/layouts/layoutAdmin.vue';

//Letter Setup
import hrmLetterInfoSetup from '@/views/module/hrm/settingsManagement/hrmLetterInfoSetup.vue';
import hrmLetterRecords from '@/views/module/hrm/settingsManagement/hrmLetterRecords.vue';

// Employees 
import hrmAddEmployee from '@/views/module/hrm/employeesManagement/hrmAddEmployee.vue';
import hrmEmployeeList from '@/views/module/hrm/employeesManagement/hrmEmployeeList.vue';
import hrmEmployeeDetails from '@/views/module/hrm/employeesManagement/hrmEmployeeDetails.vue';
import hrmEmployeeFormattedLetterView from '@/views/module/hrm/employeesManagement/hrmEmployeeFormattedLetterView.vue';

// Nominees
import hrmAddNominee from '@/views/module/hrm/employeesManagement/hrmAddNominee.vue';
import hrmNomineeList from '@/views/module/hrm/employeesManagement/hrmNomineeList.vue';

//Increment
import hrmAddIncrement from '@/views/module/hrm/incrementManagement/hrmAddIncrement.vue';
import hrmIncrementList from '@/views/module/hrm/incrementManagement/hrmIncrementList.vue';
import hrmAddIncrementV2 from '@/views/module/hrm/incrementManagement/hrmAddIncrementV2.vue';
import hrmIncrementListV2 from '@/views/module/hrm/incrementManagement/hrmIncrementListV2.vue';

//Promotion
import hrmPromotionList from '@/views/module/hrm/promotionManagement/hrmPromotionList.vue';
import hrmAddPromotion from '@/views/module/hrm/promotionManagement/hrmAddPromotion.vue';


// Claims 

import hrmClaimList from '@/views/module/hrm/claimsManagement/hrmClaimList.vue';
import hrmAddClaim from '@/views/module/hrm/claimsManagement/hrmAddClaim.vue';

// Reports 
import hrmBloodGroupReport from '@/views/module/hrm/reports/hrmBloodGroupReport.vue';
import hrmJoiningReport from '@/views/module/hrm/reports/hrmJoiningReport.vue';
import hrmIncrementReport from '@/views/module/hrm/reports/hrmIncrementReport.vue';
import hrmPromotionReport from '@/views/module/hrm/reports/hrmPromotionReport.vue';
import hrmNomineeReport from '@/views/module/hrm/reports/hrmNomineeReport.vue';
import hrmEmployeeSummaryReport from '@/views/module/hrm/reports/hrmEmployeeSummaryReport.vue';
import hrmAddInternalbill from '@/views/module/hrm/claimsManagement/hrmAddInternalbill.vue';
import hrmVisitList from '@/views/module/hrm/claimsManagement/hrmVisitList.vue';
import hrmOwnClaimList from '@/views/module/hrm/claimsManagement/hrmOwnClaimList.vue';
import viewHrmClaimInvoice from '@/views/module/hrm/claimsManagement/viewHrmClaimInvoice.vue';
import hrmEmployeeKpiReport from '@/views/module/hrm/reports/hrmEmployeeKpiReport.vue';

export default [
  {
    path: '/hrm',
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: 'Human Resource Management',
    },
    children: [
    
      //Letter Setup

      {
        path: "letter-info-setup",
        meta: {
          breadcrumb: ['Letter Info Setup']
        },
        component: hrmLetterInfoSetup,
      },
      {
        path: "letter-records",
        meta: {
          breadcrumb: ['Letter Records']
        },
        component: hrmLetterRecords,
      },

      // Employees 

      {
        path: "add-employee",
        meta: {
          breadcrumb: ['Add Employee']
        },
        component: hrmAddEmployee,
      },
      {
        path: "employee-list",
        meta: {
          breadcrumb: ['Employee List']
        },
        component: hrmEmployeeList,
      },
      {
        path: "employee-details/:id",
        name: "employee-details",
        meta: {
          breadcrumb: ['Employee Details']
        },
        component: hrmEmployeeDetails,
      },
      {
        path: "/hrm/:slug/:slug",
        name: "employee-formatted-letter",
        meta: {
          breadcrumb: ['Employee Details']
        },
        component: hrmEmployeeFormattedLetterView,
      },

      //Nominees

      {
        path: "add-nominee",
        meta: {
          breadcrumb: ['Add Nominee']
        },
        component: hrmAddNominee,
      },
      {
        path: "nominee-list",
        meta: {
          breadcrumb: ['Nominee List']
        },
        component: hrmNomineeList,
      },
      
      //Increments
      {
        path: "add-increment",
        name: "add-increment",
        meta: {
          breadcrumb: ['Add Increment']
        },
        component: hrmAddIncrement,
      },
      {
        path: "increment-list",
        name: "icrement-list",
        meta: {
          breadcrumb: ['Increment Management']
        },
        component: hrmIncrementList,
      },
      
      {
        path: "add-increment-v2",
        name: "add-increment-v2",
        meta: {
          breadcrumb: ['Add Increment']
        },
        component: hrmAddIncrementV2,
      },
      {
        path: "increment-list-v2",
        name: "icrement-list-v2",
        meta: {
          breadcrumb: ['Increment Management']
        },
        component: hrmIncrementListV2,
      },

      //Promotion
      
      {
        path: "add-promotion",
        name: "add-promotion",
        meta: {
          breadcrumb: ['Add Promotion']
        },
        component: hrmAddPromotion,
      },
      {
        path: "promotion-list",
        meta: {
          breadcrumb: ['Promotion Management']
        },
        component: hrmPromotionList,
      },

      // Claim Management

      {
        path: "claim-list",
        meta: {
          breadcrumb: ['Claim List']
        },
        component: hrmClaimList,
      },
      {
        path: "own-claim-list",
        name: "own-claim-list",
        meta: {
          breadcrumb: ['Own Claim List']
        },
        component: hrmOwnClaimList,
      },
      {
        path: "view-claim-invoice/:id",
        name: "view-claim-invoice",
        meta: {
          breadcrumb: ['Claim Invoice']
        },
        component: viewHrmClaimInvoice,
      },
      {
        path: "visit-list",
        meta: {
          breadcrumb: ['Visit List']
        },
        component: hrmVisitList,
      },
      {
        path: "add-claim",
        name: "add-claim",
        meta: {
          breadcrumb: ['Add Claim']
        },
        component: hrmAddClaim,
      },
      {
        path: "add-internal-bill",
        name: "add-internal-bill",
        meta: {
          breadcrumb: ['Add internal Bill']
        },
        component: hrmAddInternalbill,
      },

      //Reports Management

      {
        path: "blood-group-report",
        meta: {
          breadcrumb: ['Blood Group Report']
        },
        component: hrmBloodGroupReport,
      },
      {
        path: "hrm-kpi-report",
        meta: {
          breadcrumb: ['Blood Group Report']
        },
        component: hrmBloodGroupReport,
      },
      {
        path: "joining-report",
        meta: {
          breadcrumb: ['Joining Report']
        },
        component: hrmJoiningReport,
      },
      {
        path: "increment-report",
        meta: {
          breadcrumb: ['Increment Report']
        },
        component: hrmIncrementReport,
      },
      {
        path: "promotion-report",
        meta: {
          breadcrumb: ['Promotion Report']
        },
        component: hrmPromotionReport,
      },
      {
        path: "nominee-report",
        meta: {
          breadcrumb: ['Nominee Report']
        },
        component: hrmNomineeReport,
      },
      {
        path: "employee-kpi-report",
        meta: {
          breadcrumb: ['Employee KPI Report']
        },
        component: hrmEmployeeKpiReport,
      },
      {
        path: "employee-summary-report",
        meta: {
          breadcrumb: ['Employee Summary Report']
        },
        component: hrmEmployeeSummaryReport,
      },
      {
        path: "edit-claim/:id",
        name: "edit-claim",
        meta: {
          breadcrumb: ['Edit Claim']
        },
        component: hrmAddClaim,
      },

    ],
    
  },
  
]


  